// extracted by mini-css-extract-plugin
export default {"button":"kYrXSK","header":"kr6BSe","orderNumber":"evlt0u","placedOn":"oUXWFf","actions":"F45I5Y","link":"GsdS0x"};